import React, { useState } from 'react';
import {
  Box,
  ColumnLayout,
  Container,
  Header,
  SpaceBetween,
  Tabs,
  Cards,
  Link,
  StatusIndicator,
  Button,
  Badge,
  SideNavigation,
  ButtonDropdown
} from '@cloudscape-design/components';
import DomainTypeCard from './DomainTypeCard';
import DomainList from './DomainList';
import DomainDetailsPanel from './DomainDetailsPanel';

export function InitialRecommendationsTab({ entityDomainData }) {
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [selectedDomainType, setSelectedDomainType] = useState('entity');
  const [toolsOpen, setToolsOpen] = useState(false);

  const domainTypeCounts = {
    entity: entityDomainData.domains.length,
    operations: entityDomainData.domains.length,
    data: entityDomainData.domains.length 
  };

  const domainTypeDescriptions = {
    entity: "Domains identified based on entity relationships and data structures",
    operations: "Domains identified based on business operations and workflows",
    data: "Domains identified based on data access patterns and characteristics"
  };

  return (
    <SpaceBetween size="l">
      {/* Summary Cards */}
      <Container
        header={
          <Header
            variant="h2"
            description="Initial domain recommendations based on different analysis perspectives"
            actions={
              <ButtonDropdown
                items={[
                  { text: 'Export recommendations', id: 'export' },
                  { text: 'Refresh analysis', id: 'refresh' },
                  { text: 'Compare domains', id: 'compare' }
                ]}
              >
                Actions
              </ButtonDropdown>
            }
          >
            Domain Recommendations
          </Header>
        }
      >
        <ColumnLayout columns={3}>
          <DomainTypeCard
            title="Entity Domains"
            count={domainTypeCounts.entity}
            description={domainTypeDescriptions.entity}
            selected={selectedDomainType === 'entity'}
            onClick={() => setSelectedDomainType('entity')}
            status="complete"
            confidence={92}
          />
          <DomainTypeCard
            title="Operations Domains"
            count={domainTypeCounts.operations}
            description={domainTypeDescriptions.operations}
            selected={selectedDomainType === 'operations'}
            onClick={() => setSelectedDomainType('operations')}
            status="complete"
            confidence={88}
          />
          <DomainTypeCard
            title="Data Domains"
            count={domainTypeCounts.data}
            description={domainTypeDescriptions.data}
            selected={selectedDomainType === 'data'}
            onClick={() => setSelectedDomainType('data')}
            status="complete"
            confidence={90}
          />
        </ColumnLayout>
      </Container>

      {/* Domain Lists */}
       <Container
        header={
          <Header
            variant="h2"
            description={domainTypeDescriptions[selectedDomainType]}
            counter={`(${domainTypeCounts[selectedDomainType]})`}
          >
            {selectedDomainType === 'entity' && 'Entity Domains'}
            {selectedDomainType === 'operations' && 'Operations Domains'}
            {selectedDomainType === 'data' && 'Data Domains'}
          </Header>
        }
      >
        <DomainList
          type={selectedDomainType}
          onSelect={setSelectedDomain}
          setToolsOpen={setToolsOpen}
          domainsData={entityDomainData} // Pass the domain data
        />
      </Container>

      {/* Domain Details Panel */}
      <DomainDetailsPanel
        domain={selectedDomain}
        visible={toolsOpen}
        onDismiss={() => setToolsOpen(false)}
      />
    </SpaceBetween>
  );
};
